// 確認ボタンが押された時の処理
const confirmButton = document.getElementById('confirmButton');
confirmButton.addEventListener('click', () => {
    if (checkForm()) {
        formSubmit();
    }
});

const formSubmit = () => {
    const form = document.getElementById('form');
    form.action = '/pages/contact-conf';
    form.submit();
}

const checkName = () => {
    const lastName = document.getElementById('lastName').value;
    const firstName = document.getElementById('firstName').value;
    const nameEmpty = document.getElementById('nameEmpty');

    // 名前が入力されているか確認
    if (lastName == '' || firstName == '') {
        nameEmpty.style.display = 'block';
        return false;
    } else {
        nameEmpty.style.display = 'none';
        return true;
    }
}

const checkKanaName = () => {
    const kanaLastName = document.getElementById('kanaLastName').value;
    const kanaFirstName = document.getElementById('kanaFirstName').value;
    const nameKanaEmpty = document.getElementById('nameKanaEmpty');
    const nameKanaCorrectError = document.getElementById('nameKanaCorrectError');
    const pattern = /^[ァ-ンヴー]+$/;

    // 名前が入力されているか確認
    if (kanaLastName == '' || kanaFirstName == '') {
        nameKanaEmpty.style.display = 'block';
        return false;
    } else if (!pattern.test(kanaLastName) || !pattern.test(kanaFirstName)) {
        nameKanaEmpty.style.display = 'none';
        nameKanaCorrectError.style.display = 'block';
        return false;
    } else {
        nameKanaEmpty.style.display = 'none';
        nameKanaCorrectError.style.display = 'none';
        return true;
    }
}

const checkPostal = () => {
    const pattern = /^[0-9]{3}-?[0-9]{4}$/;
    const postal = document.getElementById('postal').value;
    const postalCorrectError = document.getElementById('postalCorrectError');
    if ( postal == "") {
        postalCorrectError.style.display = 'none';
        return true;
    } else if (!pattern.test(postal)) {
        postalCorrectError.style.display = 'block';
        return false;
    } else {
        postalCorrectError.style.display = 'none';
        return true;
    }

}

const checkTel = () => {
    const tel = document.getElementById('tel').value;
    const telCorrectError = document.getElementById('telCorrectError');
    const pattern = /^0[-0-9]{9,12}$/;
    if ( tel == "") {
        telCorrectError.style.display = 'none';
        return true;
    } else if (!pattern.test(tel)) {
        telCorrectError.style.display = 'block';
        return false;
    } else {
        telCorrectError.style.display = 'none';
        return true;
    }
}

const checkMail = () => {
    const mail = document.getElementById('mail').value;
    const checkMail = document.getElementById('checkMail').value;
    const mailEmpty = document.getElementById('mailEmpty');
    const mailCorrectError = document.getElementById('mailCorrectError');
    const mailMatchError = document.getElementById('mailMatchError');
    const pattern = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$/;
    if (mail == '' || checkMail == '') {
        mailEmpty.style.display = 'block';
        return false;
    } else if (!pattern.test(mail)) {
        mailEmpty.style.display = 'none';
        mailCorrectError.style.display = 'block';
        return false;
    } else if (mail != checkMail) {
        mailEmpty.style.display = 'none';
        mailCorrectError.style.display = 'none';
        mailMatchError.style.display = 'block';
        return false;
    } else {
        mailEmpty.style.display = 'none';
        mailCorrectError.style.display = 'none';
        mailMatchError.style.display = 'none';
        return true;
    }
}

const checkTextarea = () => {
    const textarea = document.getElementById('textarea').value;
    const textareaEmpty = document.getElementById('textareaEmpty');

    if (textarea == '') {
        textareaEmpty.style.display = 'block';
        return false;
    } else {
        textareaEmpty.style.display = 'none';
        return true;
    }
}

const checkForm = () => {
    const name = checkName();
    const kanaName = checkKanaName();
    const postal = checkPostal();
    const tel = checkTel();
    const mail = checkMail();
    const textarea = checkTextarea();

    if (name && kanaName && postal && tel && mail && textarea) {
        return true;
    } else {
        return false;
    }

}
